import Vue from 'vue';
import Vuex from 'vuex';

//import modules from './modules';

Vue.use(Vuex);

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGOUT = 'LOGOUT';
const SET_ROLE = 'SET_ROLE';
const DYN_CON_DONE = 'DYN_CON_DONE';
const DYN_CONTENT_LOADED = 'DYN_CONTENT_LOADED';

export default new Vuex.Store({
    state: {
        lngFront: 'fr',
        contents: [],
        selects: [],
        isDynContentLoaded: false,
        
        window: {
            width:'', 
            scroll: 0
        },
        user: {
            isLoggedIn: false,
            role: null,
            login: null,
            id: null,
        },
        appRootPath: null,
        navProjects:{cat: '', heading:'', active: false},        
    },
    getters: {
        getWindowSize(state) {
            return state.window;
        },
        
        getUserRole(state) {
            return state.userRole;
        },
        getContents(state) {
            return state.contents;
        },
        isDynContLoaded(state){
           return state.isDynContentLoaded;
        },
        currentLng(state){
            return state.lngFront;
        }
    },
    mutations: {
        [DYN_CONTENT_LOADED] (state) {
            state.isDynContentLoaded = true;
        },
        [LOGIN_SUCCESS](state, data) {
            //console.log("LOGIN_SUCCESS");
            //console.log(data);
            state.user.isLoggedIn = true;
            state.user.role = data.user_right;
            state.user.id = data.user_id;
            state.user.login = data.login;
            state.appRootPath = '/communaute';
        },
        [LOGOUT](state) {
            state.user = {
                isLoggedIn : false,
                role : null,
                id : null,
            };
            state.appRootPath = '/';
            //state.isAdmin = false;
        },
        /*
        [DYN_CON_DONE](state) {
            state.isDynContentLoaded = true;
        },*/
        
    },
    actions: {
        login({ state, commit }, creds) {
            commit(LOGIN_SUCCESS, creds);
        },
        logout({ state, commit }) {
            commit(LOGOUT);
        },
        
        dynContentLoaded({ state, commit }) {
            commit(DYN_CONTENT_LOADED);
        }
    },
    //modules
});



// WEBPACK FOOTER //
// ./src/store/index.js